import { FC } from 'react'

import { IconArrowLeft, IconArrowRight } from '~/components/ui/icons'
import { twMerge } from '~/lib/utils'

const getPageNationNumbers = (currentPage: number, totalPages: number) => {
  const pages: number[] = []

  if (totalPages <= 4) {
    // ページ数が4以下の場合はそのまま全ページを表示
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }
  } else {
    // ページ数が4より多い場合
    if (currentPage <= 2) {
      pages.push(1, 2, 3, 4)

      // 現在のページが最後の1つ前のページと、最後のページの場合
    } else if (currentPage >= totalPages - 1) {
      pages.push(totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
    } else {
      pages.push(currentPage - 1, currentPage, currentPage + 1, currentPage + 2)
    }
  }

  return pages
}

type PaginationProps = {
  currentPage: number
  totalPageCount: number
  handlePrevious: () => void
  handleNext: () => void
  handlePageClick: (page: number) => void
}

export const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPageCount,
  handlePrevious,
  handleNext,
  handlePageClick,
}) => {
  const pageNumbers = getPageNationNumbers(currentPage, totalPageCount)

  return (
    <div className="flex items-center space-x-2">
      {totalPageCount !== 1 && (
        <button
          className={twMerge(
            'flex h-[44px] w-[44px] items-center justify-center rounded border border-grayBorder',
            currentPage === 1 ? 'bg-grayBtn' : 'bg-white hover:bg-brand-bg',
          )}
          disabled={currentPage === 1}
          onClick={handlePrevious}
        >
          <IconArrowLeft />
        </button>
      )}
      {pageNumbers.map((page, index) => (
        <button
          className={twMerge(
            'flex h-[44px] w-[44px] items-center justify-center rounded border border-grayBtn font-bold',
            currentPage === page
              ? 'bg-brand text-white'
              : 'bg-white text-brand hover:bg-brand-bg',
          )}
          key={index}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ))}
      {totalPageCount !== 1 && (
        <button
          className={twMerge(
            'flex h-[44px] w-[44px] items-center justify-center rounded border border-grayBtn',
            currentPage === totalPageCount
              ? 'bg-grayBtn'
              : 'bg-white hover:bg-brand-bg',
          )}
          disabled={currentPage === totalPageCount}
          onClick={handleNext}
        >
          <IconArrowRight />
        </button>
      )}
    </div>
  )
}
